import React from 'react'
import { connect } from 'react-redux'
import LoadingSpinner from '../../components/ui/LoadingSpinner'
import { bindActionCreators } from 'redux'
import PopupFormContainer from './PopupFormContainer'

class OverlayContainer extends React.Component {

    render() {
        return (<div className="fog">{(this.props.loading) ? (< LoadingSpinner loadingMessage={this.props.loadingMessage} />) : (< PopupFormContainer popup={this.props.popup} popupInfo={this.props.popupInfo} popupFlag={this.props.popupFlag} />)} </div>)
    }

}

function mapStateToProps(state) {
    return {
        loading: state.ui.loading,
        loadingMessage: state.ui.loadingMessage,
        popup: state.ui.popup,
        popupInfo: state.ui.popupInfo,
        popupFlag: state.ui.popupFlag,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OverlayContainer)